import axios from 'axios';
import getConfig from '../getConfig';
import {Middleware} from './performQuery';
import {BEEscenicArticle} from './types';

const {api} = getConfig();

/**
 * Since the response is wrapped in a nested object, this middleware returns the relevant data only
 * @param response
 */
const getRoot: Middleware = (response): unknown => response.data.data;

/**
 * A thunk returning a query for Escenic articles.
 *
 * @param middleware
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const query = (middleware: Middleware = getRoot) => (): Promise<any> =>
  axios({
    url: `${api.escenic.root}${api.escenic.section ? '/' : ''}${api.escenic.section}/pool.json`,
    method: 'GET',
    params: {
      profile: '24media',
      version: 'light',
      groups: api.escenic.group,
    },
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(middleware);

export const getTeaserArticles = (): Promise<BEEscenicArticle[]> => query()();

export default {getTeaserArticles};
